import axios from 'axios';
import { interceptAxios } from './sentryAxios';

const instance = interceptAxios(
  axios.create({
    baseURL: '/',
  }),
);

export const saasAxios = async (
  url: any,
  requestData: any,
  // doRedirect = true,
  // dispatch = null,
) => {
  let data = null;
  try {
    data = await instance.post(url, requestData);
    // eslint-disable-next-line prefer-destructuring
    data = data.data;
    if (data.code !== 0) {
      const error = new Error(data.code);
      if (data.result) {
        (error as any).data = data.result;
      }
      throw error;
    }
  } catch (e) {
    // if (e.response && e.response.status === 401) {
    //   if (dispatch && doRedirect) {

    //   }
    // }
    throw e;
  }
  return data;
};

export default instance;
